module.exports = __webpack_public_path__ + "img/bg6.19a89273.jpg";